<template>
    <FullScreen
        ref="fullscreen"
        style="width: 100%; height: 100%"
        @fullScreenin="isFull = true"
        @fullScreenOut="isFull = false"
    >
        <div class="c-toppage" :style="'width:' + Width + 'px;'">
            <div class="top">
                <div class="top-left">
                    <div class="logo"></div>
                    <span>智慧{{ titleName }}监测系统</span>
                </div>
                <div class="top-right">
                    <img
                        class="item"
                        src="./top/imgs/manage/manage-back.png"
                        :title="$t('topNav.envTop.backToAdmin')"
                        alt=""
                        @click="manageBackFn"
                    />
                    <img
                        class="item"
                        src="./top/imgs/manage/fullscreen.png"
                        :title="$t('topNav.envTop.fullscreen')"
                        alt=""
                        @click="handleFullScreen"
                    />
                    <img
                        class="item brightness"
                        src="./top/imgs/manage/skin.png"
                        style="filter: brightness(0.5)"
                        alt=""
                    />
                    <img
                        class="item brightness"
                        src="./top/imgs/manage/notification.png"
                        style="filter: brightness(0.5)"
                        alt=""
                    />
                    <img
                        class="item brightness"
                        src="./top/imgs/manage/help.png"
                        style="filter: brightness(0.5); width: 28px; height: 28px"
                        alt=""
                    />
                    <!-- <el-popover
                        popper-class="title-popover manage-popover mark-bg_96"
                        placement="bottom"
                        width="100"
                        trigger="click"
                    >
                        <div class="info-items">
                            <div class="el-icon-message info-item" @click="userMessageFn(true)">
                                <p>您收到的站内信</p>
                                <i>查看</i>
                            </div>
                            <div class="el-icon-message info-item" @click="userMessageFn">
                                <p>您收到的代办事宜</p>
                                <i>查看</i>
                            </div>
                        </div>
                        <div class="" slot="reference">
                            <img class="item" src="./top/imgs/manage/notification.png" alt="" />
                        </div>
                    </el-popover> -->
                    <el-popover
                        popper-class="title-popover mark-bg_96"
                        placement="bottom"
                        width="100"
                        trigger="click"
                    >
                        <div class="user-items">
                            <!-- <div class="user-item" style="margin-top: 20px" @click="userInfoFn">基本资料</div> -->
                            <div class="user-item" style="margin-top: 10px" @click="homeBackFn">返回门户</div>
                            <div class="user-item" @click="logout">退出登录</div>
                        </div>
                        <div class="" slot="reference">
                            <img
                                class="item avatar"
                                :src="avatar ? avatar : defaultAvatar"
                                alt=""
                                :title="$t('topNav.envTop.personalCenter')"
                            />
                            <span>{{ account }}</span>
                        </div>
                    </el-popover>
                </div>
            </div>
            <div class="c-toppage__content" :style="'width:' + Width + 'px;'">
                <keep-alive>
                    <router-view v-if="$route.meta.keepAlive"></router-view>
                </keep-alive>
                <router-view v-if="!$route.meta.keepAlive"></router-view>
            </div>
        </div>
    </FullScreen>
</template>

<script>
import { FullScreen } from '@CommonComponent';
import g from '@global';
import api from './top/api';

export default {
    components: { FullScreen },
    data() {
        return {
            screenWidth: 0,
            Width: 1920,
            showTopType: 'main',
            account: '',
            avatar: '',
            userId: '',
            defaultAvatar: require('./top/imgs/manage/avatar.png'),
        };
    },
    computed: {
        titleName() {
            let path = this.$route.path;
            let name = '';
            if (path.includes('environmental')) {
                name = '环保';
            }
            if (path.includes('fire')) {
                name = '消防';
            }
            if (path.includes('find')) {
                name = '查违';
            }
            if (path.includes('examine')) {
                name = '监督';
            }
            if (path.includes('police')) {
                name = '公安';
            }
            if (path.includes('investigate')) {
                name = '巡航';
            }
            if (path.includes('supervisor')) {
                name = '市监';
            }
            if (path.includes('river')) {
                name = '河长';
            }
            return name;
        },
    },
    watch: {
        screenWidth: {
            handler(val, oldVal) {
                this.screenWidth = val;
                this.Width = val < 1024 && val > 0 ? 1024 : val === 0 ? 1920 : val;
            },
            immediate: true,
        },
    },
    mounted() {
        this.getCurrent();
        // console.log(this.$route);
        // 是否自动刷新token
        window.shouldAutoRefreshToken = true;
        // 监听浏览器窗口宽度改变
        window.addEventListener(
            'resize',
            () => {
                this.screenWidth = window.innerWidth;
                this.Width = this.screenWidth < 1024 ? 1024 : this.screenWidth;
            },
            true,
        );
        // 浏览器完成加载后获取窗口宽度
        // window.addEventListener('load', () => {
        this.screenWidth = window.innerWidth;
        this.Width = this.screenWidth < 1024 ? 1024 : this.screenWidth;
        // });
    },
    destroyed() {
        // 是否自动刷新token
        window.shouldAutoRefreshToken = false;
    },
    methods: {
        userMessageFn(type) {
            if (type) {
                window.location.href = '/sh_shared_uav/msg/data/msgDataDetail/toList?typeCode=site';
            } else {
                window.location.href = '/sh_shared_uav/manage/flowmine/mine/toList?typeId=1';
            }
        },
        userInfoFn() {
            window.location.href = `/sh_shared_uav/envi/organ/systemAccount/toForm?id=${this.userId}&pid=&organId=&status=&isSelf=1`;
        },
        homeBackFn() {
            window.location.href = '/sh_shared_uav/main/index';
        },
        logout() {
            api.logout()
                .run()
                .then((data) => {
                    window.location.href = data;
                });
        },
        manageBackFn() {
            window.location.href = '/sh_shared_uav/envi/main/index';
        },
        handleFullScreen() {
            this.$refs.fullscreen.toggleFullCreeen();
        },
        getCurrent() {
            return api
                .getCurrent()
                .then((data) => {
                    this.account = data.data.data.account;
                    this.avatar = `file_resource/${data.data.data.user.photo}`;
                    this.userId = data.data.data.id;
                    console.log(data.data.data, '-------------');
                })
                .catch((e) => {});
        },
    },
};
</script>

<style lang="scss" scoped>
@import '~@Theme/config.scss';
@import '~@Theme/mixins/index.scss';
::v-deep .c-environmental__left::before,
::v-deep .c-environmental__right::before,
::v-deep .c-environmental__content::before {
    height: calc(100% - 5px);
}
@include b(toppage, c) {
    position: relative;
    user-select: none;
    // width: 100vw;
    height: 100vh;
    background-color: hsl(238, 91%, 13%);
    .top {
        display: flex;
        justify-content: space-between;
        align-items: center;
        height: 66px;
        background: url('./top/imgs/manage/manage-bg.png');
        margin-bottom: 5px;
        padding: 0 10px;
        color: #fff;
        .top-left {
            display: flex;
            align-items: center;
            .logo {
                width: 60px;
                height: 36px;
                margin-right: 10px;
                background: url('./top/imgs/manage/manage-logo.png');
            }
            span {
                font-size: 28px;
            }
        }
        .top-right {
            display: flex;
            justify-content: space-between;
            align-items: center;

            .item {
                margin: 0 15px;
                width: 24px;
                height: 24px;
                cursor: pointer;
                vertical-align: text-bottom;
                &:nth-last-of-type(1) {
                    margin-right: 10px;
                }
            }
            .brightness:hover {
                cursor: not-allowed;
            }
            span {
                cursor: pointer;
            }
            .avatar {
                width: 40px;
                height: 40px;
                vertical-align: middle;
                border-radius: 50%;
            }
        }
    }
    @include e(header) {
        position: absolute;
        top: 0px;
        left: 0px;
        width: 100%;
        height: 64px;
        z-index: 1;
        overflow: hidden;
    }
    @include e(content) {
        position: absolute;
        left: 0px;
        right: 0;
        height: calc(100% - 75px);
    }
}
</style>
<style lang="scss">
// 弹窗样式
.el-popper.el-popper[x-placement^='top'] .popper__arrow::after {
    bottom: 0px;
}
.el-tree-node:focus > .el-tree-node__content {
    background-color: #66b1ff87 !important;
}
.el-tree-node__content:hover {
    background-color: #66b1ff87;
}
.el-tree--highlight-current .el-tree-node.is-current > .el-tree-node__content {
    background-color: #66b1ff87;
}
.el-popover {
    min-width: 50px;
}
.el-popper[x-placement^='bottom'] .popper__arrow::after {
    top: 0;
}

.el-popper.title-popover {
    text-align: center;
    color: white;
    padding: 0;
    border: none;
    background-clip: padding-box;
    // border-top: 15px solid transparent;
    // border-left: 15px solid transparent;
    // border-right: 15px solid transparent;
    // border-bottom: 28px solid transparent;
    // border-image: url(./imgs/mark-bg.png) 30 stretch;
    overflow: hidden;
    border-radius: 4px 4px 0 0;
    box-shadow: none;
    background-color: transparent;
    .info-items {
        padding: 10px 10px 0 10px;
        .info-item {
            width: 100%;
            // margin-top: 10px;
            height: 32px;
            line-height: 32px;
            text-align: left;
            cursor: pointer;
            p {
                display: inline-block;
                margin-left: 5px;
                width: 130px;
            }
        }
    }
    .user-item {
        width: 100%;
        height: 45px;
        text-align: center;
        line-height: 45px;
        border-bottom: 1px dashed rgba(73, 240, 253, 0.5);
        cursor: pointer;
        &:last-child {
            border-bottom: 0;
        }
    }
}
.el-popover.manage-popover {
    width: 200px !important;
}
</style>
